import {
  post,
  postJson,
  deleteApi,
  put,
  get,
  imagePost,
  putJson,
  postBlob,
} from "./axios3";

// 装修保存
export const saveDecoration = (p) => postJson(`/decorationInfo/saveByType`, p);

// 根据类型查新模板详细信息 适用于一个类型只有一个模版
export const getDecorationInfoDetail = (type) =>
  get(`/decorationInfo/detailByType/${type}`, {});

// 分页获取积分竞拍活动列表
export const pointAuctionPage = (p) =>
  postJson(`/paradiseAndTaskCommon/pointAuction/page`, p);

// 互动/京获客生成京东/云起人群
export const crowdGenerate = (p) =>
  postJson(`/crowd-generate/generateCrowBySearch`, p);
